import React, { useEffect, useState } from 'react';
import {
  Container, Typography, Box, TextField, Button, Alert
} from '@mui/material';
import { useParams, useNavigate } from 'react-router-dom';
import axiosInstance from '../../services/api';

const AdminVehicleBrandForm = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const isEdit = !!id;

  const [name, setName] = useState('');
  const [slug, setSlug] = useState('');
  const [logoUrl, setLogoUrl] = useState('');
  const [displayOrder, setDisplayOrder] = useState(0);
  const [error, setError] = useState('');

  useEffect(() => {
    if (id) {
      axiosInstance.get(`/vehiclebrands/${id}`)
        .then(res => {
          setName(res.data.name);
          setSlug(res.data.slug);
          setLogoUrl(res.data.logoUrl || '');
          setDisplayOrder(res.data.displayOrder);
        })
        .catch(() => setError('Marka bilgileri alınamadı.'));
    }
  }, [id]);

  // Addan otomatik slug üret
  const handleNameChange = (val) => {
    setName(val);
    if (!isEdit) {
      setSlug(val.toLowerCase()
        .replace(/ğ/g, 'g').replace(/ü/g, 'u').replace(/ş/g, 's')
        .replace(/ı/g, 'i').replace(/ö/g, 'o').replace(/ç/g, 'c')
        .replace(/\s+/g, '-').replace(/-+/g, '-').trim());
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const token = localStorage.getItem('adminToken');
    const data = { name, slug, logoUrl, displayOrder: Number(displayOrder) };
    try {
      if (isEdit) {
        await axiosInstance.put(`/vehiclebrands/${id}`, data, {
          headers: { Authorization: `Bearer ${token}` }
        });
      } else {
        await axiosInstance.post('/vehiclebrands', data, {
          headers: { Authorization: `Bearer ${token}` }
        });
      }
      navigate('/admin/vehicles/brands');
    } catch (err) {
      setError('Kayıt başarısız: ' + (err.response?.data || err.message));
    }
  };

  return (
    <Container maxWidth="sm">
      <Box sx={{ mt: 4 }}>
        <Typography variant="h5" fontWeight={700} sx={{ mb: 3 }}>
          {isEdit ? 'Markayı Düzenle' : 'Yeni Marka Ekle'}
        </Typography>
        {error && <Alert severity="error" sx={{ mb: 2 }}>{error}</Alert>}
        <form onSubmit={handleSubmit}>
          <TextField label="Marka Adı" fullWidth required margin="normal"
            value={name} onChange={e => handleNameChange(e.target.value)} />
          <TextField label="Slug (URL)" fullWidth margin="normal"
            value={slug} onChange={e => setSlug(e.target.value)}
            helperText="Otomatik üretilir, değiştirebilirsiniz." />
          <TextField label="Logo URL (opsiyonel)" fullWidth margin="normal"
            value={logoUrl} onChange={e => setLogoUrl(e.target.value)} />
          <TextField label="Sıralama" fullWidth margin="normal" type="number"
            value={displayOrder} onChange={e => setDisplayOrder(e.target.value)} />
          <Box sx={{ display: 'flex', gap: 2, mt: 2 }}>
            <Button type="submit" variant="contained" color="primary" fullWidth>
              {isEdit ? 'Güncelle' : 'Oluştur'}
            </Button>
            <Button variant="outlined" fullWidth onClick={() => navigate('/admin/vehicles/brands')}>
              İptal
            </Button>
          </Box>
        </form>
      </Box>
    </Container>
  );
};

export default AdminVehicleBrandForm;
